/* eslint-disable typescript-sort-keys/string-enum */
var TextFontSize;
(function (TextFontSize) {
    TextFontSize["XSMALL"] = "xsm";
    TextFontSize["SMALL"] = "sm";
    TextFontSize["DEFAULT"] = "default";
    TextFontSize["MEDIUM"] = "md";
    TextFontSize["LARGE"] = "lg";
    TextFontSize["XLARGE"] = "xlg";
    TextFontSize["XXLARGE"] = "xxlg";
})(TextFontSize || (TextFontSize = {}));
/* eslint-enable */
var TextFontFamily;
(function (TextFontFamily) {
    TextFontFamily["BOOK"] = "book";
    TextFontFamily["MEDIUM"] = "medium";
})(TextFontFamily || (TextFontFamily = {}));
var TextType;
(function (TextType) {
    TextType["PRIMARY"] = "primary";
    TextType["SECONDARY"] = "secondary";
    TextType["SIGNAL"] = "signal";
})(TextType || (TextType = {}));
var TextSignalColor;
(function (TextSignalColor) {
    TextSignalColor["SIGNAL_BLUE"] = "signal-blue";
    TextSignalColor["SIGNAL_CYAN"] = "signal-cyan";
    TextSignalColor["SIGNAL_GREEN"] = "signal-green";
    TextSignalColor["SIGNAL_INDIGO"] = "signal-indigo";
    TextSignalColor["SIGNAL_LIME"] = "signal-lime";
    TextSignalColor["SIGNAL_ORANGE"] = "signal-orange";
    TextSignalColor["SIGNAL_PINK"] = "signal-pink";
    TextSignalColor["SIGNAL_PURPLE"] = "signal-purple";
    TextSignalColor["SIGNAL_RED"] = "signal-red";
    TextSignalColor["SIGNAL_YELLOW"] = "signal-yellow";
})(TextSignalColor || (TextSignalColor = {}));
var TextSignalShade;
(function (TextSignalShade) {
    TextSignalShade["SHADE_30"] = "30";
    TextSignalShade["SHADE_40"] = "40";
    TextSignalShade["SHADE_45"] = "45";
    TextSignalShade["SHADE_50"] = "50";
    TextSignalShade["SHADE_60"] = "60";
})(TextSignalShade || (TextSignalShade = {}));
export { TextFontFamily, TextFontSize, TextSignalColor, TextSignalShade, TextType, };
//# sourceMappingURL=text-constants.js.map